/**
 * Hero rotation.
 *
 * NOTE: the source photo filenames are spelled "congreation" (missing the
 * second "g"). That is the spelling on disk in /public/assets, so it is the
 * spelling used here. If those files are ever renamed, update these paths.
 *
 * Each slide carries its own alt text. The hero is decorative-with-content:
 * the headline is real text in the DOM, and the photographs describe the
 * congregation rather than repeating the headline.
 */
export const heroSlides = [
  {
    src: '/assets/mcog-congreation.jpg',
    alt: 'The Metropolitan congregation standing together in worship in the main sanctuary.',
  },
  {
    src: '/assets/mcog-fellowship.jpg',
    alt: 'Members greeting one another in fellowship after a Sunday service.',
  },
  {
    src: '/assets/mcog-sermon-choir.jpg',
    alt: 'The choir leading the congregation in song during Sunday worship.',
  },
  {
    src: '/assets/mcog-congreation-3.jpg',
    alt: 'Worshippers with hands raised during the Sunday morning service.',
  },
  {
    src: '/assets/mcog-fellowship-1.jpg',
    alt: 'Members of Metropolitan gathered in conversation in the fellowship hall.',
  },
  {
    src: '/assets/mcog-congreation-4.jpg',
    alt: 'A full sanctuary during Sunday worship at Metropolitan Church of God.',
  },
  {
    src: '/assets/mcog-fellowship-2.jpg',
    alt: 'Members sharing a meal together during a fellowship gathering.',
  },
];

/** The four cards beneath the hero on the home page. */
export const homeTiles = [
  {
    title: 'Visitors',
    eyebrow: 'Start here',
    description: 'What to expect on your first Sunday, where to park, and how to find us.',
    href: '/visiting/location-service-times',
    image: '/assets/mcog-usher.jpg',
    alt: 'An usher welcoming visitors at the sanctuary doors.',
  },
  {
    title: 'This Week',
    eyebrow: 'Calendar',
    description: 'Services, classes, and gatherings happening at Metropolitan this week.',
    href: '/news-events/calendar',
    image: '/assets/mcog-service-0.jpg',
    alt: 'The sanctuary set for a Sunday morning service.',
  },
  {
    title: 'Upcoming Classes',
    eyebrow: 'Education Institute',
    description: 'Structured biblical study, in person and on Zoom. No membership required.',
    href: '/education/bible-study',
    image: '/assets/biblestudy.png',
    alt: 'An open Bible on a study table.',
  },
  {
    title: 'Media',
    eyebrow: 'Watch online',
    description: 'Join the live broadcast on Sunday morning or revisit a past service.',
    href: '/watch/live',
    image: '/assets/mcog-congreation-vertical.jpg',
    alt: 'The congregation gathered during a broadcast service.',
  },
];
